import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { SnotifyService } from 'ng-snotify';

import { CoreService } from 'src/app/core/core.service';
import { Cart, Item } from 'src/app/interfaces/cart';
import { CartService } from 'src/app/services/cart.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'cm-course-card-product',
  templateUrl: './course-card-product.component.html',
  styleUrls: ['./course-card-product.component.scss']
})
export class CourseCardProductComponent implements OnInit {
  @Input() image!: string;
  @Input() url_register!: string;
  @Input() url_login!: string;
  @Input() tag: string = 'SimSave';
  @Input() slug: string;


  constructor (
    private _coreService: CoreService,
    private _snotifyService: SnotifyService,
    private _formBuilder: FormBuilder,
    private _cartService: CartService,
  ) { }

  ngOnInit() {
    
  }
}
